module.exports = __webpack_public_path__ + "img/ic_report.5e6f6241.svg";